import { useMutation } from '@tanstack/react-query';

import { CreateUser, createUser } from '../api';
import { usersQueryKeys } from '../data';

import { useResetUserQueries } from './use-reset-user-queries';

export const useCreateUserMutation = () => {
  const resetUserQueries = useResetUserQueries();

  return useMutation({
    mutationKey: [...usersQueryKeys.createUser],
    mutationFn: (params: CreateUser['param']) => createUser(params),
    onSuccess: () => {
      resetUserQueries();
    },
  });
};
